import useEvent from 'react-use-event-hook'
import { useApi } from '../api/ApiContext'
import useEffectOnce from '../hooks/useEffectOnce'
import { useAppFrame } from './AppFrameContext'

export default function ReCaptcha() {
  const appFrame = useAppFrame()
  const api = useApi()

  const technical = appFrame?.settings?.technical || {}
  const { captchaId, captchaType, turnStileSiteKey, captchaVisibility } = technical
  //  const captchaId = technical?.captchaId
  //  const captchaVisibility = technical?.captchaVisibility

  const initCaptchaEvent = useEvent(async () => {
    api.connector.setupCaptcha(captchaType, captchaId, turnStileSiteKey, captchaVisibility)
  })

  useEffectOnce(() => {
    if (!captchaId) return false
    void initCaptchaEvent()
  }, [captchaId, initCaptchaEvent])

  return null
}
